import StringFilterModel from "@/components/Tables/Filters/models/stringFilterModel";
import {
  defaultHistoryFields,
  isDeletedField
} from "@/components/Tables/defaultFields";

let usersFields = [
  {
    key: "name",
    label: "Имя",
    filter: new StringFilterModel()
  },
  {
    key: "login",
    label: "Логин",
    filter: new StringFilterModel()
  },
  {
    key: "rights",
    label: "Права",
    filter: new StringFilterModel(),
    formatter: value =>
      value.map(({ display_name: displayName }) => displayName).join(", ")
  },
  {
    key: "roles",
    label: "Роли",
    filter: new StringFilterModel(),
    formatter: value =>
      value.map(({ display_name: displayName }) => displayName).join(", ")
  }
];

const userHistoryFields = [...usersFields, ...defaultHistoryFields];

usersFields.push(isDeletedField);

export { usersFields, userHistoryFields };
